module.exports = __webpack_public_path__ + "static/media/b4.dc89bb0a.svg";